import { render, staticRenderFns } from "./ApprovedConsumsGrid.vue?vue&type=template&id=413f1352&scoped=true"
import script from "./ApprovedConsumsGrid.vue?vue&type=script&lang=js"
export * from "./ApprovedConsumsGrid.vue?vue&type=script&lang=js"
import style0 from "./ApprovedConsumsGrid.vue?vue&type=style&index=0&id=413f1352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f1352",
  null
  
)

export default component.exports